<!-- Messages toggle -->
<button mat-icon-button (click)="openPanel()" #messagesOrigin>
  @if (unreadCount() > 0) {
    <span
      class="absolute left-0 right-0 top-0 z-10 flex h-3 items-center justify-center"
    >
      <span
        class="ml-4 mt-2.5 flex h-4 min-w-4 shrink-0 items-center justify-center rounded-full bg-accent px-1 text-[0.6875rem] font-medium text-indigo-50"
      >
        {{ unreadCount() }}
      </span>
    </span>
  }
  <mat-icon [svgIcon]="'heroicons_outline:inbox'"></mat-icon>
</button>

<!-- Messages panel -->
<ng-template #messagesPanel>
  <div
    class="fixed inset-0 flex flex-col overflow-hidden bg-[var(--mat-dialog-container-color)] shadow-lg sm:static sm:inset-auto sm:w-128 sm:min-w-128 sm:rounded-2xl"
  >
    <!-- Header -->
    <div class="flex shrink-0 items-center gap-4 border-b p-8">
      <div class="-ml-1 mr-3 sm:hidden">
        <button mat-icon-button (click)="closePanel()">
          <mat-icon
            class="text-current icon-size-5"
            [svgIcon]="'heroicons_solid:x-mark'"
          ></mat-icon>
        </button>
      </div>
      <div
        class="flex h-10 w-10 items-center justify-center rounded-full bg-accent"
      >
        <mat-icon
          class="text-default icon-size-6"
          [svgIcon]="'heroicons_outline:inbox'"
        ></mat-icon>
      </div>
      <div class="text-default text-xl font-semibold leading-6">Messages</div>
    </div>

    <!-- Content -->
    <div
      class="relative flex flex-auto flex-col divide-y overflow-y-auto sm:max-h-120"
    >
      <!-- Messages -->
      @for (message of messages(); track trackByFn($index, message)) {
        <app-message [message]="message" (close)="closePanel()"></app-message>
      }

      <!-- No messages -->
      @if (!messages() || !messages().length) {
        <div
          class="flex h-64 flex-auto flex-col items-center justify-center gap-2 p-8"
        >
          <div class="text-default text-2xl font-semibold leading-relaxed">
            No messages
          </div>
          <div class="text-default text-center text-base leading-5 opacity-80">
            When you have messages,<br />
            they will appear here.
          </div>
        </div>
      }
    </div>

    <!-- Footer -->
    <div class="bg-dialog-footer flex w-full justify-end border-t px-6 py-4">
      <button
        class="w-1/2 min-w-28 sm:w-auto"
        mat-stroked-button
        (click)="closePanel()"
      >
        Close
      </button>
    </div>
  </div>
</ng-template>
